import React from "react";
//#region types
import { TableAsyncPrintRowProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import { View, Text } from "@react-pdf/renderer";
import useValueFormatter from "../useValueFormatter";
//#endregion
import tableAsyncStyles from "theme/custom/tableAsyncPdf";

const TableAsyncPrintRow: React.FC<TableAsyncPrintRowProps> = (props) => {
  const { row, index, columns, nonSpecifiedColumnWidth } = props;

  const { getFormattedValueForPrint } = useValueFormatter();

  return (
    <View>
      <View style={tableAsyncStyles.row} wrap={false}>
        {columns.map(([key, cellValue], cellIndex) => (
          <View
            key={`tab-cell-${index}${cellIndex}`}
            style={[
              tableAsyncStyles.tableCell,
              tableAsyncStyles.truncateString,
              cellValue?.isTextSmall ? tableAsyncStyles.textSmall : tableAsyncStyles.textNormal,
              {
                width: cellValue?.pdfColumnwidth ?? nonSpecifiedColumnWidth,
                textAlign:
                  cellValue?.alignment === undefined || cellValue?.alignment === "inherit"
                    ? "left"
                    : cellValue?.alignment,
                flexWrap: cellValue?.noWrap ? "nowrap" : "wrap",
              },
            ]}
          >
            <Text style={tableAsyncStyles.rowMainText}>
              {getFormattedValueForPrint(
                cellValue?.valueToPrint
                  ? cellValue?.valueToPrint(row, index)
                  : cellValue?.formatter
                  ? cellValue.formatter(row, index)
                  : row[key]
              )}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
};

export default TableAsyncPrintRow;
